import { TimerLockOutlineIcon } from './TimerLockOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 5849E09F-FAFC-40A5-9A30-D4B9BFB87BCC
 * name timer-lock-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-lock-outline.svg
 * tags
 * - Date / Time 
 * - Lock 
 */
export const TimerSecureOutlineIcon = TimerLockOutlineIcon;
export default TimerSecureOutlineIcon